module.exports = __webpack_public_path__ + "static/media/menu_sites.db9dfaf1.png";